module.exports = __webpack_public_path__ + "static/media/list_item_map_marker.fcaa994a.svg";